import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import TYPES from '../../../config/Types'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import { IStatement } from '../../../model/statement'
import { Meta } from '../../../model/meta'
import { IReference } from '../../../model/reference'

export default async function fetchReferences(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.getReferences(statement).then((references: IReference[]) => {
        statementStore.commitSetReferences({ statement: statement, references: references })
    })

    return
}
